import {useEffect} from "react";

const PanelPage = () => {
    useEffect(() => {
        document.location.href = "https://racing-school.ru:6574/panel"
    }, [])
    return(<></>);
}

export default PanelPage;